import { Card } from "shared/components/Card";
import Pets from "shared/icons/pets.svg?react";
import { Money } from "types/landlord/reports";
import { formatToCurrency } from "shared/utils";

import { RoundedMathSymbol } from "views/applications-id/components/ApplicationMonthlyRentCard/components/RoundedMathSymbol";

interface ApplicationMonthlyRentCardProps {
  monthly_rent_amount?: Money;
  pet_rent_value?: Money;
  pets_count?: number;
  has_voucher?: boolean;
  voucher_amount?: Money;
}

export const ApplicationMonthlyRentCard = ({
  monthly_rent_amount,
  pet_rent_value,
  pets_count = 0,
  has_voucher,
  voucher_amount
}: ApplicationMonthlyRentCardProps) => {
  if ((!pet_rent_value?.cents || !pets_count) && !has_voucher) return null;

  const pet_rent_value_cents = pet_rent_value?.cents || 0;
  const voucher_amount_cents = has_voucher ? (voucher_amount?.cents ?? 0) : 0;

  return (
    <Card className="flex w-full gap-2 p-6 text-content-1000 font-medium">
      <div className="grow">
        <p className="text-sm mb-2">Application monthly rent</p>
        <p className="font-bold text-xl">
          {monthly_rent_amount
            ? monthly_rent_amount.cents > 0
              ? formatToCurrency({
                  cents:
                    monthly_rent_amount.cents +
                    pets_count * pet_rent_value_cents -
                    voucher_amount_cents,
                  currency: "USD"
                })
              : "$0"
            : "-"}
        </p>
      </div>

      <div className="flex items-center grow">
        <RoundedMathSymbol symbol="=" />
        <div className="flex gap-6 items-center">
          <div className="flex flex-col gap-2 text-sm">
            <p className="text-content-1000">Listing rent</p>
            <p className="text-content-300">
              {monthly_rent_amount
                ? formatToCurrency({
                    cents: monthly_rent_amount.cents,
                    currency: "USD"
                  })
                : "-"}
            </p>
          </div>
        </div>
      </div>

      {pets_count && pet_rent_value_cents ? (
        <div className="flex items-center grow">
          <RoundedMathSymbol symbol="+" />
          <div className="flex gap-4 items-center">
            <Pets width={24} height={24} className="text-content-300" />
            <div className="flex flex-col gap-2 text-sm">
              <p className="text-content-1000">Pet rent</p>
              <p className="text-content-300">
                {pet_rent_value
                  ? formatToCurrency({
                      cents: pet_rent_value.cents,
                      currency: "USD"
                    })
                  : "-"}{" "}
                / pet * {pets_count} pets
              </p>
            </div>
          </div>
        </div>
      ) : null}

      {has_voucher && voucher_amount_cents ? (
        <div className="flex min-w-fit w-1/4 items-center">
          <RoundedMathSymbol symbol="-" />
          <div className="flex gap-6 items-center">
            <div className="flex flex-col gap-2 text-sm">
              <p>Housing assistance</p>
              <p className="text-content-300">
                {formatToCurrency({
                  cents: voucher_amount_cents,
                  currency: "USD"
                })}
              </p>
            </div>
          </div>
        </div>
      ) : null}
    </Card>
  );
};
